export default [
  {
    path: "/guide",
    name: "guide",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Справочники",
      permissions: [
        "tank:index",
        "fuel:index",
        "transport:index",
        "driver:index",
        "counterparty:index",
        "user:index",
        "role:index",
        "station:index",
      ],
    },
  },
  {
    path: "/guide/inventory",
    name: "inventory",
    component: () => import("./pages/inventory/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Инвентаризация резервуаров",
    },
  },
  {
    path: "/guide/lang",
    name: "lang",
    component: () => import("./pages/lang/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Языки",
    },
  },
  {
    path: "/guide/metrology",
    name: "metrology",
    component: () => import("./pages/metrology/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Метрологическое оборудование",
      permissions: ["metrology_equipment:index"],
    },
  },
  {
    path: "/guide/users",
    name: "users",
    component: () => import("@/modules/guide/pages/users/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Пользователи",
      permissions: ["user:index"],
    },
  },
  {
    path: "/guide/roles",
    name: "roles",
    component: () => import("@/modules/guide/pages/roles/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Роли",
      permissions: ["role:index"],
    },
  },
  {
    path: "/guide/roles/:id",
    name: "role",
    component: () => import("@/modules/guide/pages/roles/open.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Роль",
      permissions: ["role:show"],
    },
  },
  {
    path: "/guide/loading-points",
    name: "loading-points",
    component: () => import("@/modules/guide/pages/loading-points/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Пункты загрузки",
    },
  },
  {
    path: "/guide/stations",
    name: "stations",
    component: () => import("@/modules/guide/pages/stations/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Станции",
      permissions: ["station:index"],
    },
  },
  {
    path: "/guide/fuels",
    name: "fuels",
    component: () => import("@/modules/guide/pages/fuels/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Типы топлива",
      permissions: ["fuel:index"],
    },
  },
];
